import React, { Component } from 'react';

const withSearchState = WrappedComponent =>
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        searchQuery: '',
        inSearchMode: false,
        onProduct: null,
        onProductName: '',
        sortBy: 'date-desc',
        sortSelectOption: 'date-desc',
      };
    }

    onSortChanged = (selectedOption, refetch) => {
      this.setState(
        {
          sortSelectOption: selectedOption.value,
          sortBy: selectedOption.value,
        },
        () => {
          refetch({
            sortBy: this.state.sortSelectOption,
            offset: 0,
            limit: 3,
          });
        }
      );
    };

    onProductClicked = (productID, productName) => {
      this.setState({
        onProduct: parseInt(productID, 10),
        onProductName: productName || '',
        inSearchMode: false,
        sortBy: 'date-desc',
        sortSelectOption: 'date-desc',
      });
    };

    onSearchUpdate = searchMode => {
      if (searchMode) {
        this.setState({
          inSearchMode: true,
        });
      } else {
        this.setState({
          inSearchMode: false,
          onProduct: null,
          sortBy: 'date-desc',
          sortSelectOption: 'date-desc',
        });
      }
    };

    render() {
      return (
        <WrappedComponent
          searchQuery={this.state.searchQuery}
          onSearchUpdate={this.onSearchUpdate}
          inSearchMode={this.state.inSearchMode}
          onProductClicked={this.onProductClicked}
          onProduct={this.state.onProduct}
          onProductName={this.state.onProductName}
          onSortChanged={this.onSortChanged}
          sortSelectOption={this.state.sortSelectOption}
          sortBy={this.state.sortBy}
          {...this.props}
        />
      );
    }
  };

export default withSearchState;
